
// gives the components an inView and seen property that tells you if it is onscreen, or has been seen yet
export default{
  data () {
    return {
      inView: false,
      seen: false,
      goneBelow: false,
      mounted: false
    }
  },
  mounted () {
    this.setUp()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setInView)
  },
  methods: {
    async setUp() {
      await this.$k.waitfor(200)
      this.mounted = true
      window.addEventListener('scroll', this.setInView)
      this.setInView()
    },
    async setInView () {
      if(!this.mounted) {
        this.seen = false
        return
      }
      try {
        const bounding = this.$el.getBoundingClientRect();
        this.inView = (
            bounding.bottom >= 0 &&
            bounding.top <= (window.innerHeight || document.documentElement.clientHeight) 
        )
        if(this.inView) {
          this.seen = true
        }
        if(this.seen || (bounding.top <= (window.innerHeight || document.documentElement.clientHeight)))
        {
          this.goneBelow = true
        }
      }
      catch(err) {
        console.log('ViewablePanel', err)
        console.log('$el', this.$el)
      }
      
    }
  }
  
}

